import React, { useEffect } from 'react';
import { CONFIG } from './config/config';
import { getOS } from './lib/os.lib';
import useTranslate from './hooks/useTranslate';
import CustomImage from './components/Shared/CustomImage';
import { Button, QRCode } from 'antd';
import routes from './routes';

const mobilePlatforms = ['android', 'ios'];

interface Props {
  home?: boolean;
}

const MobileAppDownload: React.FC<Props> = ({ home }: Props) => {
  const t = useTranslate();
  const platform = getOS();

  const url =
    (platform === 'android'
      ? CONFIG.ANDROID_TANKS_APP_URL
      : CONFIG.IOS_TANKS_APP_URL) || '';

  useEffect(() => {
    if (!home) {
      window.location.href = url;
    }
  }, []);

  const qrUrl =
    location.protocol + '//' + location.host + routes.mobile_app_download();

  return (
    <div className="s-home">
      <div className="tanks-app" id="tanks-app">
        <div className="block block__full block__inverted-on-mobile">
          <div className="content half left">
            <CustomImage pageName="home" imageName="tanks-app" />
          </div>
          <div className="content half right">
            <div className="titles">
              <h3>{t({ id: 'TANKS_APP.TITLE' })}</h3>
              <h4>{t({ id: 'TANKS_APP.SUBTITLE' })}</h4>
            </div>
            <p>{t({ id: 'TANKS_APP.TEXT' })}</p>
            <div className="qr">
              {!mobilePlatforms.includes(platform) && (
                <QRCode value={qrUrl} size={132} />
              )}
              {mobilePlatforms.includes(platform) && (
                <Button
                  className="layout-button"
                  onClick={() => {
                    window.location.href = url;
                  }}
                >
                  {t({ id: 'TANKS_APP.DOWNLOAD' })}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppDownload;
